import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ApacheIIScoreExampleRows from "../model";
import ApacheIIScore from "../create";
import ByzMuiEditButton from "src/components/core-components/mui/buttons/ByzMuiEditButton";
import { useTranslate } from "src/locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

//CKAPISIZ;446187;17032025
const columns: GridColDef[] = [
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzMuiEditButton link={`edit/${params.row.id}`} />;
    },
  },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function ApacheIIScoreList() {
  const { t } = useTranslate();
  
  return (
    <BaseMedCardList
      title={t("apacheii-score.title")}
      CreateComponent={ApacheIIScore}
      columns={columns}
      rows={ApacheIIScoreExampleRows}
    />
  );
}

export default ApacheIIScoreList;
